export default __webpack_public_path__ + "static/media/book-inhalt2.2fe2a967.png";